import React, { Component } from 'react';
import PageTitle from './PageTitle';
import OwlCarousel from 'react-owl-carousel';
import {Link} from 'react-router';

export default class Services extends Component {
    render() {
        return (
            <div>
                <PageTitle title="Serviços" last="Home" lastLink="/" />
                <section className="section-padding bg-fixed parallax-bg overlay light-7">
                    <div className="container">

                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">O QUE NÓS FAZEMOS</h2>
                            <p className="section-sub">
                                Atuamos como fabrica de software, de duas formas agindo no desenvolvimento de novas soluções e também sustentando
                                sistemas já existentes criando novas funcionalidades. Nossa equipe utiliza de ferramentas e linguagem de ponta para prover nossas soluções.
                            </p>

                        </div>


                        <div class="row">
                            <div class="col-md-4">
                                <div class="featured-item flat-border-box">
                                    <div class="icon">
                                        <i class="material-icons brand-icon"></i>
                                    </div>
                                    <div class="desc">
                                        <h2>Gestão Educacional</h2>
                                        <p>
                                            Nosso sistema foi desenvolvido para tornar a gestão escolar uma experiência mais amigável e rápida.
                                            Focando no controle e integração dos setores acadêmicos, pedagógico e financeiro.
                                        </p>
                                        <br/>
                                        <Link className="readmore" to="/solutions/retail">Ver Mais <i class="fa fa-long-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="featured-item flat-border-box">
                                    <div class="icon">
                                        <i class="material-icons brand-icon"></i>
                                    </div>
                                    <div class="desc">
                                        <h2>Gestão para Verejo</h2>
                                        <p>
                                            O software foi desenvolvido para gerir com maxima eficiência todas especificidades do setor. Desde frente de caixa a negociações com fornecedores.
                                            Tudo pode ser facilmente acompanhado e gerido com facilidade através do nosso sistema.
                                        </p>
                                        <Link className="readmore" to="/solutions/educational">Ver Mais <i class="fa fa-long-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="featured-item flat-border-box">
                                    <div class="icon">
                                        <i class="material-icons brand-icon"></i>
                                    </div>
                                    <div class="desc">
                                        <h2>Soluções Customizadas</h2>
                                        <p>A FC Sistemas realiza desenvolvimento de projetos sob demanda, customizando a solução para seu negócio. E ainda mantém aplicações já existentes com alterações melhorias e correções.</p>
                                        <br/>
                                        <Link className="readmore" to="/solutions/custom">Ver Mais <i class="fa fa-long-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>                      

                    </div>
                </section>

                <section className="padding-top-110 padding-bottom-70 brand-bg">
                    <div className="container">
                        <div className="col-md-8 col-md-offset-2">
                            <OwlCarousel loop autoplay autoplayTimeout={6000} dots items={1} className={'text-center owl-carousel owl-theme owl-loaded'}>

                                <div className="item carousel-item">
                                    <div className="content">
                                        <h2 className="white-text line-height-40">"Com organização e tempo, acha-se o segredo de fazer tudo e bem feito."</h2>

                                        <div className="testimonial-meta font-20 text-extrabold white-text">
                                            Pitágoras
                                        </div>
                                    </div>
                                </div>

                                <div className="item carousel-item">
                                    <div className="content">
                                        <h2 className="white-text line-height-40">"A persistência é o caminho do êxito."</h2>

                                        <div className="testimonial-meta font-20 text-extrabold white-text">
                                            Charles Chaplin
                                        </div>
                                    </div>
                                </div>

                                <div className="item carousel-item">
                                    <div className="content">
                                        <h2 className="white-text line-height-40">"As pessoas não sabem o que querem, até mostrarmos a elas."</h2>

                                        <div className="testimonial-meta font-20 text-extrabold white-text">
                                            Steve Jobs
                                        </div>
                                    </div>
                                </div>
                            </OwlCarousel>
                        </div>
                    </div>
                </section>



                <section className="section-padding bg-fixed parallax-bg overlay light-9" data-stellar-background-ratio="0.5">
                    <div className="container">

                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">Tecnologias que usamos</h2>
                            <p className="section-sub"></p>
                        </div>

                        <OwlCarousel loop margin={10} autoplay autoplayTimeout={4000} dots className={'owl-carousel owl-theme brand-dot'} dotsEach={3} slideBy={3}>
                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/anguler-logo.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>Angular JS</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/node-logo.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>Node JS</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/react.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>React</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/java.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>Java</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/php.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>PHP</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/net.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>.NET</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/mysql.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>MySql</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/mongodb.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>MongoDB</h2>
                                </div>
                            </div>

                            <div className="featured-item border-box radius-4 hover brand-hover">
                                <div className="icon mb-30">
                                    <img src="assets/img/oracle.png" alt="" />
                                </div>
                                <div className="desc">
                                    <h2>Oracle DB / PlSql</h2>
                                </div>
                            </div>
                        </OwlCarousel>

                    </div>
                </section>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Services.js